import styles from './Button.module.css';

/**
 * @param {object} props
 * @param {'pu'|'dk'|'cr'|'se'|'gh'} [props.variant]  pu (purple) / dk (dark) / cr (crimson) / se (secondary) / gh (ghost)
 * @param {'xs'|'sm'} [props.size]
 */
export default function Button({
  variant = 'se',
  size,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const cls = [
    styles.btn,
    styles[variant] || styles.se,
    size ? styles[size] : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
